import type { Point } from '../../state/types';
import { RECOGNITION_CONFIG } from '../config';
import { perpendicularDistance } from '../geometry';

export interface LineFit {
  start: Point;
  end: Point;
  straightness: number;
}

export const fitLine = (points: Point[]): LineFit => {
  const start = points[0] ?? { x: 0, y: 0 };
  const end = points[points.length - 1] ?? start;

  let maxDeviation = 0;
  for (const p of points) {
    const deviation = perpendicularDistance(p, start, end);
    maxDeviation = Math.max(maxDeviation, deviation);
  }

  const lineLength = Math.hypot(end.x - start.x, end.y - start.y);
  const straightness =
    lineLength === 0
      ? 0
      : 1 - maxDeviation / (lineLength * RECOGNITION_CONFIG.lineStraightnessScale);

  return { start, end, straightness };
};
